<template>
<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		<div class="content">
			<div style="height:80px;"></div>
			<div class="enclosure">
				<div class="inner">
					<div class="left">
						<SideMenu />
					</div>
					<div class="right">
						<div class="caption">
							<span>{{$t('personCenter')}}</span><span class="arrow"><i class="iconfont icon-jiantou2"></i></span><span>{{$t('phoneVerify.title')}}</span>
						</div>
						<div class="tag-outer">
							<p class="phone-verify-page__desc">{{$t('phoneVerify.desc')}}</p>
							<PhoneVerifyForm
								:masked-mobile="maskedMobile"
								:has-mobile="hasMobile"
								@success="onVerified"
							/>
							<div class="phone-verify-page__link">
								<a href="javascript:void(0);" @click="goNotice">{{$t('phoneVerify.toNotice')}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
	import phone_verify from './phone_verify_controller';
	export default phone_verify;
</script>

<style src="@/assets/css/my/setting.css" scoped></style>
<style scoped>
.phone-verify-page__desc {
	margin: 0 0 20px;
	color: #666;
	line-height: 1.6;
}
.phone-verify-page__link {
	margin-top: 8px;
}
.phone-verify-page__link a {
	color: rgb(64, 158, 255);
	text-decoration: none;
}
.tag-outer {
	max-width: 480px;
}
</style>
